export const GRID_Z = -0.01
export const FLOOR_Z = 0
export const BACKGROUND_Z = 0.5
export const CURSOR_Z = 0.75
export const DIMENSION_ARROW_Z = 1.0

export const ARROW_OFFSET = 0.5
